export default [
    {   // 客户仓容分配
        path: "storageallocation/storageallocation",
        name: "allocationDetail",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/storageallocation/index"),
    },
    {
        // 添加客户仓容分配
        path: "storageallocation/storageallocation/update/:type",
        name: "allocationDetailUpdate",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/storageallocation/update.vue"),
    },
    {
        // 库容预测报表
        path: "storageallocation/storageforecast",
        name: 'storageForecast',
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/storageforecast/index"),
    },
    {   // 出库预测
        path: "storageallocation/outboundcalculate",
        name: "outboundCalculateDetail",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/outboundcalculate/index"),
    },
    {
        // 添加出库预测
        path: "storageallocation/outboundcalculate/update/:type",
        name: "outboundCalculateUpdate",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/outboundcalculate/update.vue"),
    },
    {
        // 出库分析
        path: "storageallocation/outboundanalysis",
        name: "outboundAnalysis",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/outboundanalysis/index"),
    },
    {   // 客户配置
        path: "storageallocation/outboundconfig",
        name: "outboundConfig",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/outboundconfig/index"),
    },
    {
        // 添加出库预测
        path: "storageallocation/outboundconfig/update/:type",
        name: "outboundConfigUpdate",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/outboundconfig/update.vue"),
    },
    {   // 出库预测报表
        path: "storageallocation/outboundforecast",
        name: "outboundForecast",
        component: () => import(/* webpackChunkName: "setting" */ "@/views/storageallocation/outboundforecast/update.vue"),
    },
]


